<template>
  <!-- 出库确认 -->
  <div class="pagesBox">
    <div ref="box1" style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button
        style="margin-top: 10px"
        class="glo_bgcMainColor"
        @click="saveBtns"
        >出库确认</el-button
      >
    </div>
    <div ref="box2" class="formbox">
      <el-form
        :model="baseInForm"
        :rules="rules"
        ref="baseInForm"
        label-width="130px"
        class="glo_formBox"
      >
        <el-form-item label="出库仓库:" prop="outStockDeptId">
          <el-select
            style="width: 100%"
            v-model="baseInForm.outStockDeptId"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="item in storageList"
              :key="item.documentI"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="目的仓库:" prop="descStorageId">
          <el-select
            style="width: 100%"
            v-model="baseInForm.descStorageId"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="item in storageList"
              :key="item.documentI"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="出库人:">
          <el-select
            style="width: 100%"
            v-model="baseInForm.outStorageEmployeeId"
            placeholder="请选择"
            clearable
            filterable
            @visible-change="getEmps"
          >
            <el-option
              v-for="emp in emps"
              :key="emp.employeeId"
              :label="emp.jobNumber"
              :value="emp.employeeId"
            >
              <span style="float: left">{{ emp.jobNumber }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                emp.employeeName
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库时间:">
          <el-date-picker
            v-model="baseInForm.outStorageTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="选择日期"
            default-time="12:00:00"
          >
          </el-date-picker>
        </el-form-item>

        <!-- <el-form-item label="操作人:">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="自动获取"
            clearable
            readonly
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="操作时间:">
          <el-input
            v-model="baseInForm.aaa"
            placeholder="自动获取"
            clearable
            readonly
          ></el-input>
        </el-form-item> -->

        <el-form-item
          class="textArea"
          style="width: 100%"
          label="备注:"
          prop="comment"
        >
          <el-input
            type="textarea"
            rows="3"
            v-model="baseInForm.comment"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div ref="box3" class="formbox formbox2">
      <el-form
        :model="baseInForm"
        ref="baseInForm"
        label-width="130px"
        class="glo_formBox"
      >
        <el-button class="removeBTns" type="primary" @click="delList()"
          >移除</el-button
        >
        <div class="teSu">
          <el-form-item label="运单号:" prop="waybillNumber">
            <el-input
              v-model="baseInForm.waybillNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-button class="glo_bgcMainColor formBtns" @click="getWaybillList()"
            >添加</el-button
          >
        </div>
        <div class="teSu">
          <el-form-item label="发车批次号:" prop="pcNumber">
            <el-input
              v-model="baseInForm.pcNumber"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-button
            class="glo_bgcMainColor formBtns"
            @click="getWaybillByDispatchNumber()"
            >添加</el-button
          >
        </div>
      </el-form>
    </div>
    <div class="glo_Table" style="margin-bottom: 20px">
      <el-table
        @selection-change="handleSelectionChange"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        style="width: 100%"
        :height="tableHeigth"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'waybillNumber' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="left"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel" @click.stop="goYdDetails(scope.row)">
                {{ scope.row.waybillNumber }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-else-if="item.field == 'waybillStatusShow' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                style="color: #f00"
                v-if="scope.row.waybillStatus == 'yi_zuo_fei:waybill_status'"
              >
                {{ scope.row.waybillStatusShow }}
              </div>
              <div v-else>{{ scope.row.waybillStatusShow }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  components: { uploadimgs },
  data() {
    return {
      baseInForm: {
        waybillNumber: "",
        outStockDeptId: "",
        descStorageId: "",
        dispatchIds: [],
        comment: "",
        pcNumber: "",
        outStorageEmployeeId: "",
        outStorageTime: "",
      },
      tableData: [],
      rules: {
        outStockDeptId: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
      },
      CustomerList: [],
      selectTableData: [],
      storageList: [],
      emps: [],
      // 默认表头
      myTableHeard: [
        {
          name: "客户编号",
          field: "customerNumber",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "客户名称",
          field: "customerName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "客户单号",
          field: "customereOrderNumber",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "180",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "原运单号",
          field: "mainWaybillNumber",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "拆单状态",
          field: "splitOrderStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运单状态",
          field: "waybillStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "在途状态",
          field: "onwayStatusShow",
          width: "110",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货状态",
          field: "takeStatusShow",
          width: "110",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "存在未完成的仓配任务",
          field: "isHasTaskNoCompleteShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "最新运输任务状态",
          field: "taskStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "外发状态",
          field: "outgoingStatusShow",
          width: "110",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "当前网点",
          field: "currentDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务员",
          field: "businessName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "是否开票",
          field: "isInvoiceShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "开票税点",
          field: "taxes",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务时间",
          field: "businessDate",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "终端网点",
          field: "endDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "业务网点",
          field: "businessDeptName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "外发承运商",
          field: "outboundCarrierName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运输方式",
          field: "transportMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货方式",
          field: "receiveMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "送货方式",
          field: "sendMethod",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单方式",
          field: "rnRequireName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "回单份数",
          field: "rnRequireCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "开单运费",
          field: "billingAmount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "收货省份",
          field: "receiveProvinceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货城市",
          field: "receiveCityName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货区县",
          field: "receiveAreaName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货详细地址",
          field: "receiveAddress",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货单位",
          field: "receiveCompany",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货人",
          field: "receiveContacts",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "收货电话",
          field: "receivePhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货省份",
          field: "takeProvinceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货城市",
          field: "takeCityName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货区县",
          field: "takeAreaName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货详细地址",
          field: "takeAddress",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货地址数量",
          field: "takeAddressCount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货单位",
          field: "takeCompany",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货人",
          field: "takeContacts",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "发货电话",
          field: "takePhone",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建时间",
          field: "createTime",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "创建人",
          field: "createUserName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "订单号",
          field: "orderNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      tableHeigth: "62vh",
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getObjectUserDownList("storage"); // 网点列表
  },
  activated() {
    this.$nextTick((res) => {
      this.fetTableHeight();
    });
  },
  destroyed() {},
  methods: {
    delList() {
      if (this.selectTableData.length == 0) {
        this.$message.error("请选择需要移除的运单");
        return false;
      }
      this.$confirm("确定移除选中运单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // waybillSplitId
          let listA = JSON.parse(JSON.stringify(this.tableData)) || [];
          const resultArray = listA.filter(
            (itemA) =>
              !this.selectTableData.some(
                (itemB) => itemA.waybillSplitId === itemB.waybillSplitId
              )
          );
          console.log("resultArray", resultArray);
          this.tableData=resultArray
        })
        .catch(() => {});
    },
    saveBtns() {
      if (this.selectTableData.length < 1) {
        this.$message.error("请选择需要出库确认的运单");
        return false;
      }
      let ids = [];
      this.selectTableData.forEach((item) => {
        ids.push(item.waybillSplitId);
      });

      let param = {
        comment: this.baseInForm.comment || "",
        descStorageId: this.baseInForm.descStorageId || "",
        dispatchIds: this.baseInForm.dispatchIds || [],
        waybillSplitIds: ids || [],
        outStockDeptId: this.baseInForm.outStockDeptId || "",
        outStorageEmployeeId: this.baseInForm.outStorageEmployeeId || "",
        outStorageTime: this.baseInForm.outStorageTime || "",
      };
      this.$API.wtl_outStockSure(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        for (var a = 0; a < this.tableData.length; a++) {
          if (ids.indexOf(this.tableData[a].waybillSplitId) != -1) {
            this.tableData.splice(a, 1);
          }
        }
      });
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          if (key == "dept") {
            this.depList = arrs;
          }
          if (key == "storage") {
            this.storageList = arrs;
          }
        });
    },
    async getEmps(e) {
      if (!e) return;
      if (!this.emps || this.emps.length === 0) {
        const res = await this.$API.runList({
          number: "down_list_employee",
        });
        this.emps = res;
      }
    },
    // 根据运单号获取运单信息  YD20221129102110   YD20221128164218
    getWaybillList() {
      if (!this.baseInForm.waybillNumber) {
        this.$message.error("运单号不能为空");
        return false;
      }
      let param = {
        waybillNumber: this.baseInForm.waybillNumber,
      };
      this.$API.wtl_getWaybillList(param).then((res) => {
        let datas = res.data.result.data || [];

        let tdatas = JSON.parse(JSON.stringify(this.tableData));
        let yid = tdatas.map((item) => {
          return item.waybillSplitId;
        });
        for (var a = 0; a < datas.length; a++) {
          if (yid.indexOf(datas[a].waybillSplitId) !== -1) {
            datas.splice(a, 1);
            a--;
          }
        }
        let endDatas = [...tdatas, ...datas];
        this.tableData = endDatas;
        this.$refs.mytable.doLayout();
      });
    },
    // 根据发车批次号获取运单信息  D20221128181050   D20221124153504
    getWaybillByDispatchNumber() {
      this.$API
        .wtl_getWaybillByDispatchNumber({ number: this.baseInForm.pcNumber })
        .then((res) => {
          let datas = res.data.result || [];
          let tdatas = JSON.parse(JSON.stringify(this.tableData));
          let yid = tdatas.map((item) => {
            return item.waybillSplitId;
          });
          for (var a = 0; a < datas.length; a++) {
            if (yid.indexOf(datas[a].waybillSplitId) != -1) {
              datas.splice(a, 1);
              a--;
            }
          }
          let endDatas = [...tdatas, ...datas];
          this.tableData = endDatas;
          this.$refs.mytable.doLayout();
        });
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度

      let h1 = this.$refs.box1.offsetHeight; //
      let h2 = this.$refs.box2.offsetHeight; //
      let h3 = this.$refs.box3.offsetHeight; //

      var otherHeight = h1 + h2 + h3 + 60 + 35; //60是顶部导航
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */
  },
};
</script>
<style scoped lang='less'>
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}

.formbox {
  padding: 10px 30px 20px;

  .jsInput {
    .jsBtns {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 10px;
      border: none;
    }
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .checkBoxStyle {
    width: 23%;
    min-width: 260px;
    margin-bottom: 10px;

    display: flex;
    align-items: center;
  }

  .glo_formBox {
    .teSu {
      display: flex;
      width: 480px;
      min-width: 380px;
    }
    /deep/ .el-form-item {
      width: 380px;
      margin-bottom: 10px;
    }
  }
}
.formbox2 {
  padding: 0 30px;
}

.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}

.topBtns {
  margin: 0 30px;
  height: 50px;
}

.removeBTns {
  margin-bottom: 5px;
  padding: 10px 20px;
  height: 35px;
  margin-right: 20px;
}
</style>